import { data } from "jquery";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LocalService } from "app/services/local.service";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class DeliveryUsersService {
  apiUrl = ''
    // JSON.parse(localStorage.getItem("client"))["apiUrl"] || environment.apiUrl;

  constructor(private http: HttpClient, public localService: LocalService) {
    if(localStorage.getItem("client")){
      this.apiUrl = JSON.parse(localStorage.getItem("client"))['apiUrl'] || environment.apiUrl
    } else {
      this.apiUrl = environment.apiUrl

    }
  }
  getDeliveryPartners(search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "aggregator/listing-analytics/getDeliveryPartnersList",
        search,
        {
          headers: headers,
        }
      )
      .map((response) => response)
      .toPromise();
  }
  getNewDeliveryPartners(search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "aggregator/listing-analytics/newRegistredPartners",
        search,
        {
          headers: headers,
        }
      )
      .map((response) => response)
      .toPromise();
  }
  getOrdersDeliveryPartner(recordID, search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl +
          "deliveryPartner/getAllOrders?deliveryPartnerID=" +
          recordID,
        search,
        {
          headers: headers,
        }
      )
      .map((response) => response)
      .toPromise();
  }
  getDeliveryPartnerOrders(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "deliveryPartner/getOrders", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  // getDeliveryPartnersFilter(search): Promise<any> {
  //     const headers = new HttpHeaders({
  //         'Content-Type': 'application/json',
  //         'x-access-token': localStorage.getItem('token')
  //     });

  //     return this.http.post(this.apiUrl + 'aggregator/listing-analytics/getDeliveryPartnersList',search,{
  //         headers: headers
  //     }).map((response) => response).toPromise();
  // }
  createDeliveryPartner(record): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "deliveryPartner/createNewUser", record, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  updateDeliveryPartner(recordData): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "deliveryPartner/updateDetailsComplete", recordData, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  getDeliveryPartnerDetails(recordId): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .get(
        this.apiUrl +
          "aggregator/listing-analytics/getDeliveryPartnerDetails?deliveryPartnerID=" +
          recordId,
        {
          headers: headers,
        }
      )
      .map((response) => response)
      .toPromise();
  }

  getRegisteredRiders(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .get(this.apiUrl + "deliveryPartner/getRegisteredRiders", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getTopDeliveryPartners(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .get(this.apiUrl + "deliveryPartner/getTopRiders", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  /**
   * Change Delivery Partner Status
   */
  changeDPStatus(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "deliveryPartner/updatePartnerStatus", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  // Get Online Delivery Partners List

  getOnlineDeliveryPartners(search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "deliveryPartner/getRiderList", search, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  //Force Logout Rider
  forceLogoutRider(phone_no): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "deliveryPartner/forceLogout/" + phone_no,
        {},
        {
          headers: headers,
        }
      )
      .map((response) => response)
      .toPromise();
  }

  //Search Rider By Name

  getRidersByName(term: string, type: any) {
    console.log(type);
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "deliveryPartner/searchRider",
        { name: term, type: type },
        {
          headers: headers,
        }
      )
      .pipe(map((response) => response["data"].slice(0, 10)));
  }

  //Delete Rider
  deleteRider(id: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .delete(this.apiUrl + "deliveryPartner/deleteRider/" + id, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
}
